import { createAction, createReducer } from '@reduxjs/toolkit';

export interface VdpScrollState {
  scrollToVehicleInfo: boolean;
  srpScrollPosition: number | null;
  srpScrolledToBottom: boolean;
}

const setScrollToVehicleInfo = createAction<boolean>('vdpScroll/setScrollToVehicleInfo');
const setSrpScrollPosition = createAction<number | null>('vdpScroll/setSrpScrollPosition');
const setSrpScrolledToBottom = createAction<boolean>('vdpScroll/setSrpScrolledToBottom');

const initialState: VdpScrollState = {
  scrollToVehicleInfo: false,
  srpScrollPosition: null,
  srpScrolledToBottom: false,
};

const vdpScrollReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setScrollToVehicleInfo, (state, action) => {
      return { ...state, scrollToVehicleInfo: action.payload };
    })
    .addCase(setSrpScrollPosition, (state, action) => {
      return { ...state, srpScrollPosition: action.payload };
    })
    .addCase(setSrpScrolledToBottom, (state, action) => {
      return { ...state, srpScrolledToBottom: action.payload };
    });
});

export { vdpScrollReducer, setScrollToVehicleInfo, setSrpScrollPosition, setSrpScrolledToBottom };
